import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

import TicketsManagerTabs from "../../components/TicketsManagerTabs";
import Ticket from "../../components/Ticket";

import { TicketsContext } from "../../context/Tickets/TicketsContext";
import { i18n } from "../../translate/i18n";
import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";

const useStyles = makeStyles(theme => ({
    chatContainer: {
        flex: 1,
        padding: "0px",
        height: "100%",
        overflowY: "hidden",
        display: "flex",
        flexDirection: "column",
        marginBottom: "10px",
    },
    content: {
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        flex: 1,
        minHeight: 0
    },
    placeholderContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        background: theme.palette.tabHeaderBackground,
    },
    placeholderItem: {
    }
}));

const TicketAdvanced = (props) => {
    const classes = useStyles();
    const { ticketId } = useParams();
    const [option, setOption] = useState(0);
    const { currentTicket, setCurrentTicket } = useContext(TicketsContext)

    useEffect(() => {
        if (currentTicket.id !== null) {
            setCurrentTicket({ id: currentTicket.id, code: '#open' })
        }
        if (!ticketId) {
            setOption(1);
        }
        return () => {
            setCurrentTicket({ id: null, code: null })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (currentTicket.id !== null) {
            setOption(0);
        }
    }, [currentTicket]);

    useEffect(() => {
        if (ticketId && ticketId !== "undefined") {
            setOption(0);
        } else {
            setOption(1);
        }
    }, [ticketId]);

    const renderPlaceholder = () => {
        return (
            <Box className={classes.placeholderContainer}>
                <div className={classes.placeholderItem}>{i18n.t("chat.noTicketMessage")}</div><br />
                <Button onClick={() => setOption(1)} variant="contained" color="primary">
                    Selecionar Ticket
                </Button>
            </Box>
        );
    }

    const renderMessageContext = () => {
        if (ticketId && ticketId !== "undefined") {
            return <Ticket />;
        }
        return renderPlaceholder();
    }

    const renderTicketsManagerTabs = () => {
        return <TicketsManagerTabs />;
    }

    return (
        <QueueSelectedProvider>
            <div className={classes.chatContainer}>
                <Box className={classes.content}>
                    {option === 0 ? renderMessageContext() : renderTicketsManagerTabs()}
                </Box>
            </div>
        </QueueSelectedProvider>
    );
};

export default TicketAdvanced;
